import { FC, useEffect, useRef } from "react";
import "../../../styles/components.css";
import { StandardHandler } from "../../../middleware/handlers/standard-handler";

interface PropertiesMenuProps {
  propertiesPanelReveal: boolean;
}

export const PropertiesMenu: FC<PropertiesMenuProps> = ({
  propertiesPanelReveal,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    if (propertiesPanelReveal) {
      StandardHandler.MountPropertiesPanel(container);
      StandardHandler.ShowModelElementProperties();
    } else {
      StandardHandler.UnmountPropertiesPanel();
    }

    return () => {
      StandardHandler.UnmountPropertiesPanel();
    };
  }, [propertiesPanelReveal]);

  if (!propertiesPanelReveal) return null;

  return (
    <div id="propertiesMenu">
      <div id="propertiesWrapper" ref={containerRef} />
    </div>
  );
};

export default PropertiesMenu;
